import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { DisabledTimeFn, PanelMode, PresetRanges, SupportTimeOptions } from 'ng-zorro-antd/date-picker/standard-types';

export interface AlainDateRangePickerConfig {
  /**
   * é»è®¤ï¼`yyyy-MM-dd`
   */
  nzFormat?: string;
  nzClassName?: string;
  nzSize?: string;
  nzStyle?: string;
  /**
   * é»è®¤ï¼`true`
   */
  nzAllowClear?: boolean;
  /**
   * é»è®¤ï¼`false`
   */
  nzAutoFocus?: boolean;
  nzDisabledDate?: (d: Date) => boolean;
  nzDisabledTime?: DisabledTimeFn;
  /**
   * é»è®¤ï¼`{ position: 'relative' }`
   */
  nzPopupStyle?: object;
  nzDropdownClassName?: string;
  nzRenderExtraFooter?: string;
  nzShowTime?: SupportTimeOptions | boolean;
  /**
   * é»è®¤ï¼`true`
   */
  nzShowToday?: boolean;
  nzMode?: PanelMode | PanelMode[];
  nzRanges?: PresetRanges;
  shortcuts?: AlainDateRangePickerShortcut;
}

export interface AlainDateRangePickerShortcut {
  /** Whether to enable, default: `false` */
  enabled?: boolean;
  /** Whether to close the panel after clicking, default: `true` */
  closed?: boolean;
  /**
   * Shortcut list, default: `ä»å¤©`, `æ¨å¤©`, `è¿3å¤©`, `è¿7å¤©`, `æ¬å¨`, `æ¬æ`, `å¨å¹´`
   */
  list?: AlainDateRangePickerShortcutItem[];
}

export interface AlainDateRangePickerShortcutItem {
  [key: string]: NzSafeAny;

  text: string;
  fn: (value: [Date, Date]) => [Date, Date];
}
